import { useState } from "react";
import { MLink } from "@/lib/marketing/m-link";
import { Button } from "@/components/ui/button";
import { icon } from "@/lib/icons/icon";
import { ChevronRightIcon as g_ChevronRightIcon } from "@hugeicons/core-free-icons";
import { NavLink } from "@/components/marketing/site/marketing-shell-types";

const ChevronRight = icon(g_ChevronRightIcon);

/** One collapsible run of links in the phone menu, with its own open state. */
export function MobileGroup({
  label,
  links,
  testId,
  defaultOpen,
  onNavigate,
}: {
  label: string;
  links: NavLink[];
  testId: string;
  defaultOpen: boolean;
  onNavigate: () => void;
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div>
      <Button
        variant="ghost"
        className="w-full justify-between font-ui"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        data-testid={`button-${testId}-mobile-group`}
      >
        {label}
        <ChevronRight
          className={`size-4 text-muted-foreground transition-transform ${open ? "rotate-90" : ""}`}
          aria-hidden="true"
        />
      </Button>
      {open && (
        <div className="flex flex-col gap-1" data-testid={`group-${testId}-mobile`}>
          {links.map((l) => (
            <Button
              key={l.href}
              variant="ghost"
              className="w-full justify-start pl-6 font-ui"
              onClick={onNavigate}
              data-testid={`${l.testId}-mobile`}
              asChild
            >
              <MLink href={l.href}>{l.label}</MLink>
            </Button>
          ))}
        </div>
      )}
    </div>
  );
}
